export const userActionStartByApiCallEventName = 'faroApiCall';
export const userActionStart = 'user_action_start';
export const UserActionImportance = {
    Normal: 'normal',
    Critical: 'critical',
};
export const userActionEventName = 'faro.user.action';
//# sourceMappingURL=const.js.map